import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../images/services-usa/cloud-infra/banner_infra.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service iphone_banner cloud_mig cloud_infra"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={8} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              {/* <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                Cloud Migration Services
              </h1> */}
              <h1 className="mb-0" style={{ color: "#000" }}>
                Cloud Infrastructure Management Services
              </h1>
              <p style={{ color: "#898989" }}>
                Get a robust and agile cloud infrastructure for your business to
                stay competitive and innovative. Our Cloud Infrastructure
                Management services offer comprehensive solutions specific to
                meet your organization's needs by using the power and security
                of Microsoft Azure and Google Cloud. Utilizing a distinct
                approach to address modern business challenges, we assist you in
                developing an infrastructure that is prepared for the future.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Connect!
              </Link>
            </div>
          </Col>
          <Col xs={12} md={4} lg={5} xl={5} xxl={5} className="my-auto">
            <StaticImage
              src="../../images/services-usa/cloud-infra/banner_infra_cloud.webp"
              alt="tekrevol_web"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={916}
              height={830}
            />
            {/* <img src={GIF} alt="TekRevol" /> */}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
